import React from "react";

interface AppLoaderProps {
  label?: string;
}

export default function AppLoader({ label = "CARREGANDO" }: AppLoaderProps) {
  return (
    <div className="loader-screen" role="status" aria-live="polite" aria-label="Tela de carregamento">
      <div className="loader-stage">
        <div className="loader-docs-3d" aria-hidden="true">
          <span className="loader-doc doc-a" />
          <span className="loader-doc doc-b" />
          <span className="loader-doc doc-c" />
          <span className="loader-stamp">OK</span>
        </div>
        <div className="loader-text">{label}</div>
      </div>
    </div>
  );
}
